import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/NoticeDetail.css'; // 공지사항 전용 스타일

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function NoticeDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [notice, setNotice] = useState(null);
  const [error, setError] = useState(false);

  const applyLazyLoading = (htmlContent) => {
    if (!htmlContent) return "";
    return htmlContent.replace(/<img /g, '<img loading="lazy" ');
  };

  const getLangData = (item, field) => {
    const lang = (i18n.language || 'KR').toLowerCase();
    return item[`${field}_${lang}`] || item[`${field}_kr`] || item[field] || "";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // 공지사항 상세 데이터를 가져오는 API 호출 (기존 api가 id를 지원한다고 가정)
    fetch(`${API_BASE}/api/notice_detail.php?id=${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Notice not found');
        return res.json();
      })
      .then(data => {
        setNotice(data);
        setError(false);
      })
      .catch(err => {
        console.error(err);
        setError(true);
      });
  }, [id]);

  const processedContent = useMemo(() => {
    if (!notice) return "";
    const rawHtml = getLangData(notice, 'content');
    return applyLazyLoading(rawHtml);
  }, [notice, i18n.language]);

  if (error) {
    return (
      <div className="sub-page-container error-page">
        <p>{t('no_data', '존재하지 않는 공지사항입니다.')}</p>
        <button className="back-btn" onClick={() => navigate('/notice')}>
          <FaArrowLeft /> {t('common_list', '목록으로')}
        </button>
      </div>
    );
  }

  const title = notice ? getLangData(notice, 'title') : "Loading...";
  const pageTitle = notice ? `${title} | ${t('nav_notice')}` : t('nav_notice');

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={title} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:url" content={`https://hanjiwoo.com/notice/${id}`} />
        <link rel="canonical" href={`https://hanjiwoo.com/notice/${id}`} />
      </Helmet>
      
      {!notice ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="sub-page-container notice-detail-page">
          <article className="notice-article">
            <header className="notice-article-header">
              <div className="notice-meta">
                <span className="notice-category">{notice.category || "GENERAL"}</span>
                <span className="notice-date">{notice.date?.replace(/-/g, '.')}</span>
              </div>
              <h1 className="notice-article-title">{title}</h1>
            </header>
            
            <div className="article-divider"></div>
            
            {/* 공지사항 본문 - Quill 에디터 스타일 유지 */}
            <div 
              className="notice-article-content ql-editor" 
              dangerouslySetInnerHTML={{ __html: processedContent }} 
            />
            
            <footer className="notice-article-footer">
              <button className="list-btn" onClick={() => navigate('/notice')}>
                <FaArrowLeft size={14} /> {t('common_list', 'LIST')}
              </button>
            </footer>
          </article>
        </div>
      )}
    </>
  );
}